import { DiscountItemsConverter } from './discount-items-converter';
import { ModifierConverter } from './modifier-converter';
import { getItemId } from '../utils/menuItems';

/** Converter for Square order line items <-> Paytronix menu items. */
export class MenuItemsConverter {
  /**
   * Converts Square order line items to Paytronix menu items.
   * @param lineItems Square order line items.
   * @param orderLineItemDiscounts Discounts applied to the order.
   * @returns Paytronix menu items.
   */
  static squareToPaytronix(lineItems, orderLineItemDiscounts, cardNumber) {
    return lineItems.map((lineItem) => {
      const appliedOrderLineItemDiscounts = (lineItem.appliedDiscounts ?? [])
        .map((appliedDiscount) => {
          const orderLineItemDiscount = orderLineItemDiscounts.find(
            (orderLineItemDiscount) =>
              orderLineItemDiscount.uid === appliedDiscount.discountUid
          );

          return orderLineItemDiscount;
        })
        .filter(
          (appliedOrderLineItemDiscount) => !!appliedOrderLineItemDiscount
        );

      const totalLineItemDiscounts = appliedOrderLineItemDiscounts.reduce(
        (accumulator, orderLineItemDiscount) =>
          accumulator + Number(orderLineItemDiscount.appliedMoney?.amount ?? 0),
        0
      );
      const totalPriceWithoutDiscount =
        Number(lineItem.basePriceMoney?.amount ?? 0) *
        Number(lineItem.quantity ?? 0);

      return {
        type: 'menuItem',
        itemId: getItemId(lineItem),
        referenceLine: lineItem.uid,
        name: lineItem.name ?? '',
        quantity: lineItem.quantity ?? '0',
        isTaxable: (lineItem.appliedTaxes ?? []).length > 0,
        discounts: DiscountItemsConverter.squareToPaytronix(
          appliedOrderLineItemDiscounts?.filter(
            (discount) => !discount?.metadata?.modifierUid
          ),
          cardNumber
        ),
        price: (totalPriceWithoutDiscount - totalLineItemDiscounts) / 100,
        fullPrice: totalPriceWithoutDiscount / 100,
        modifiers: lineItem.modifiers?.map((modifier) =>
          ModifierConverter.squareToPaytronix(
            modifier,
            DiscountItemsConverter.squareToPaytronix(
              appliedOrderLineItemDiscounts?.filter(
                (discount) => discount?.metadata?.modifierUid === modifier.uid
              ),
              cardNumber
            )
          )
        ),
      };
    });
  }
}
